import React, { useState } from 'react';
import {
  Divider,
  IconButton,
  Menu,
  MenuItem,
} from '@mui/material';

import { useDispatch, useSelector } from 'react-redux';

import AccountCircle from '@mui/icons-material/AccountCircle';
import { RootState } from '../../store';
import { actions } from '../../services/auth';



const UsderMenu: React.FC = () => {
  const [ anchorEl, setAnchorEl ] = useState(null);
  const dispatch = useDispatch();

  const user = useSelector((state: RootState) => state.auth.user);

  const handleMenu = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onSignOut = () => {
    handleClose();
    dispatch(actions.logout());
  }


  return (
    <div>
      <IconButton
        size="large"
        onClick={handleMenu}
        color="inherit"
      >
        <AccountCircle />
      </IconButton>
      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        sx={{width: 350}}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem disabled>
          {user?.name}
        </MenuItem>
        <Divider />
        <MenuItem onClick={onSignOut}>Logout</MenuItem>
      </Menu>
    </div>
  )
}

export default UsderMenu;